module.exports = __webpack_public_path__ + "static/media/073-togo.240c060b.svg";